import type { DrawingMode } from "../types";

export function createLeafletDrawing(map: any, mode: DrawingMode) {
  return {
    activate() {
      console.log("Activating Leaflet drawing mode:", map, mode);
    },

    deactivate() {},
  };
}
